import { render, staticRenderFns } from "./share-link-modal.vue?vue&type=template&id=a98c1da0&scoped=true"
import script from "./share-link-modal.vue?vue&type=script&lang=js"
export * from "./share-link-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98c1da0",
  null
  
)

export default component.exports